export default __webpack_public_path__ + "img/840d81ed6f8e5ef4deeee1228bb7bdb4.jpg";